import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { ObsicashService } from "./obsicash.service";
import { Country } from "../../shared/models/country";
import { Bank } from "../../shared/models/bank";
import { Currency } from "../../shared/models/currency";
import { CurrencyByProject } from "../../shared/models/currencyByProject";
import { StatusMigration } from "../../shared/models/enum/statusMigration";
import { DocumentIdentification } from "../../shared/models/documentIdentification";
import { AccountWallet } from "../../shared/models/accountWallet";
import { ObsicashAssociateAccountService } from "./obsicash-associateAccount.service";
import { ObsicashOnboardingService } from "./obsicash-onboarding.service";
import { AccountBank } from "../../shared/models/accountBank";
import { UserInfo } from "../../shared/models/userInfo";
import { OnboardingObsicash } from "../../shared/models/onboardingObsicash";
import { ObsidiamJweComponent } from "projects/obsidiam-jwe/src/public-api";
import { environment } from "src/environments/environment";
import { UserService } from "../user.service";
import { DocumentIdentificationPast } from "src/app/shared/models/DocumentIdentificationPast";
import { BlueBank } from "src/app/shared/models/blueBank";
import { data } from "jquery";
import { AccountWalletAll } from "src/app/shared/models/accountWalletAll";
import { ExchangeService } from "../exchange.service";

@Injectable({ providedIn: "root" })
export class ObsicashStoreService {
  unsubscribe$: Subject<void> = new Subject<void>();
  loadingCountry = false;
  userData: any;
  constructor(
    private obsicashService: ObsicashService,
    private userService: UserService,
    public exchangeService: ExchangeService,
    private obsicashAssociateAccountService: ObsicashAssociateAccountService,
    private obsidiamJweComponent: ObsidiamJweComponent,
    private obsicashOnboardingService: ObsicashOnboardingService
  ) {
    this.userData = userService.getLoggedData();
    if (this.userService.getToken() && this.userService.getToken().token) {
      // onboarding Coltefinanciera
      if (localStorage.getItem("onboarding")) {
        this.onboarding = JSON.parse(localStorage.getItem("onboarding"));
      }
      // onboarding BlueBank
      if (localStorage.getItem("onboardingBlueBank")) {
        this.onboardingBlueBank = JSON.parse(
          localStorage.getItem("onboardingBlueBank")
        );
        if (this.onboardingBlueBank.setting) {
          this.fetchAllBlueBankGlobal(
            this.onboardingBlueBank.setting,
            this.onboardingBlueBank.project.id
          );
        }
      }
      if (localStorage.getItem("onboardingDidi")) {
        this.onboardingDidi = JSON.parse(
          localStorage.getItem("onboardingDidi")
        );

        this.getAdditionDataDidi().then((a) => {


          this.fetchAllDidiGlobal(
            this.onboardingDidi.setting,
            this.onboardingDidi.project.id
          );
        });
      }
      this.fetchAllInfoUserDocuments();
      this.fetchAllAccountWallets();
      this.fetchAllAccountWalletsObsicash().then();
      this.fetchAllAccountsBank();
      this.fetchAllTransactionHistory();
      this.fetchAllCountries().then();
      this.getAllCurrencies();
      this.fetchAllAccountWalletsObsicash().then();
      this.getAccountInfoDidi("").then();
    }
  }

  async getAllFiatAccount(lng) {
    // const req={
    //   currency:true
    // }
    // await this.obsicashService.getFiatAccountList(req,lng).toPromise().then(
    //   (response)=>{
    //     if(response.status ){
    //       console.log(response)
    //       let data = response.data.filter((fiat) => {
    //         return fiat.cryptoType === "FIAT"})
    //       this._coinFiatList.next(data)
    //       return false

    //     }else{
    //       this._coinFiatList.next([])
    //     }
    //   }
    // );

    // const req = {
    //   currency: true
    // }
    let query = '?fiat=true'
    await this.exchangeService.getExchangeBalance(query)
      .pipe(takeUntil(this.unsubscribe$)).toPromise().then((m: any) => {
        if (m.status == 200) {
          m.data = m.data.map((a) => {
            a.shortName = a.asset;
            a.imageURL = a.imageUrl;
            return a;
          });

          let data = m.data.filter((fiat) => {
            return fiat.cryptoType === "FIAT"
          })

          if(data.length > 0){
            let coin =[]
            data.forEach((fiat) => {
              if(!fiat.onboardingEnabled){
                coin.push({
                  fullName: fiat.fullName,
                  asset:fiat.asset
                })
              }
            });
            sessionStorage.setItem('fiatDisabledOnboarding', JSON.stringify(coin))
          }
          // console.log(data)
          this._coinFiatList.next(data)
          return false
        } else {
          this._coinFiatList.next([]);
        }
      });
  }
  /**
   * - We set the initial state in BehaviorSubject's constructor
   * - Nobody outside the Store should have access to the BehaviorSubject
   *   because it has the write rights
   * - Writing to state should be handled by specialized Store methods
   * - Create one BehaviorSubject per store entity, for example if you have TodoGroups
   *   create a new BehaviorSubject for it, as well as the observable$, and getters/setters
   */
  private readonly _enabledModules = new BehaviorSubject<[]>([]);
  readonly enabledModules$ = this._enabledModules.asObservable();

  private readonly _onboarding = new BehaviorSubject<OnboardingObsicash>(
    new OnboardingObsicash()
  );
  readonly onboarding$ = this._onboarding.asObservable();

  private readonly _countries = new BehaviorSubject<Country[]>([]);
  readonly countries$ = this._countries.asObservable();

  private readonly _onboardingBlueBank =
    new BehaviorSubject<OnboardingObsicash>(new OnboardingObsicash());
  readonly onboardingBlueBank$ = this._onboardingBlueBank.asObservable();

  private readonly _onboardingDidi = new BehaviorSubject<OnboardingObsicash>(
    new OnboardingObsicash()
  );
  readonly onboardingDidi$ = this._onboardingDidi.asObservable();

  private readonly _didiAdditionalData = new BehaviorSubject<any>({});
  readonly didiAdditionalData$ = this._didiAdditionalData.asObservable();

  // Observable for currencies all
  private readonly _currenciesAll = new BehaviorSubject<Currency[]>([]);
  readonly currenciesAll$ = this._currenciesAll.asObservable();
  private readonly _currenciesByProject = new BehaviorSubject<CurrencyByProject[]>([]);
  readonly currenciesByProject$ = this._currenciesByProject.asObservable();

  private readonly _blueBankAdditionalData = new BehaviorSubject<any>([]);
  readonly blueBankAdditionalData$ =
    this._blueBankAdditionalData.asObservable();

  private readonly _onboardingDocuments = new BehaviorSubject<any>([]);
  readonly onboardingDocuments$ = this._onboardingDocuments.asObservable();

  private readonly _additionalData = new BehaviorSubject<any>([]);
  readonly additionalData$ = this._additionalData.asObservable();

  private readonly _globalBlueBank$ = new BehaviorSubject<Country[]>([]);
  readonly globalBlueBank$ = this._globalBlueBank$.asObservable();

  private readonly _transactionHistory = new BehaviorSubject<any[]>([]);
  readonly transactionHistory$ = this._transactionHistory.asObservable();

  private readonly _accountBanks = new BehaviorSubject<AccountBank[]>([]);
  readonly accountBanks$ = this._accountBanks.asObservable();
  private readonly _accountInfoDidi = new BehaviorSubject<AccountBank[]>([]);
  readonly accountInfoDidi$ = this._accountInfoDidi.asObservable();

  private readonly _bankAccountBanks = new BehaviorSubject<AccountBank[]>([]);
  readonly bankAccountBanks$ = this._bankAccountBanks.asObservable();

  private readonly _infoUserDocuments = new BehaviorSubject<UserInfo[]>([]);
  readonly infoUserDocuments$ = this._infoUserDocuments.asObservable();

  private readonly _verifyUserDocuments = new BehaviorSubject<
    DocumentIdentification[]
  >([]);
  readonly verifyUserDocuments$ = this._verifyUserDocuments.asObservable();

  private readonly _accountWallets = new BehaviorSubject<AccountWallet[]>([]);
  readonly accountWallets$ = this._accountWallets.asObservable();

  private readonly _accountWalletsAll = new BehaviorSubject<any>([]);
  readonly accountWalletsAll$ = this._accountWalletsAll.asObservable();

  private readonly _loadingWallet = new BehaviorSubject<boolean>(true);
  readonly loadingWallet$ = this._loadingWallet.asObservable();

  private readonly _loadingObsicash = new BehaviorSubject<boolean>(true);
  readonly loadingObsicash$ = this._loadingObsicash.asObservable();

  private readonly _loadingOnboarding = new BehaviorSubject<boolean>(true);
  readonly loadingOnboarding$ = this._loadingOnboarding.asObservable();

  private readonly _lng = new BehaviorSubject<string>("");
  readonly lng$ = this._lng.asObservable();

  private readonly _verifyUserDocumentsColte = new BehaviorSubject<
    DocumentIdentificationPast[]
  >([]);
  readonly verifyUserDocumentsColte$ = this._verifyUserDocumentsColte.asObservable();
  private readonly _verifyUserDocumentsBB = new BehaviorSubject<
    DocumentIdentificationPast[]
  >([]);
  readonly verifyUserDocumentsBB$ = this._verifyUserDocumentsBB.asObservable();
  private readonly _verifyUserDocumentsDidi = new BehaviorSubject<
    DocumentIdentificationPast[]
  >([]);
  readonly verifyUserDocumentsDidi$ =
    this._verifyUserDocumentsDidi.asObservable();

  readonly generalCountries$ = this.countries$.pipe(
    map((countries$) =>
      countries$.filter((countries) => {
        return countries.code != "US" && countries.code != "CW";
      })
    )
  );
  private readonly _coinFiatList = new BehaviorSubject<[]>([]);
  readonly coinFiatList$ = this._coinFiatList.asObservable();
  /**
   * we will compose all the observables with the map operator to create a flow of only the pending countries
   */
  readonly countriesPending$ = this.countries$.pipe(
    map((countries$) =>
      countries$.filter((countries) => {
        return !countries.idProject;
      })
    )
  );
  /**
   * we will compose all the observables with the map operator to create a flow of only the active countries
   */
  readonly countriesActive$ = this.countries$.pipe(
    map((countries$) => countries$.filter((countries) => countries.idProject))
  );
  /**
   * we will compose all the observables with the map operator to create a flow of only the Documents Main Obsidiam
   */
  readonly infoUserDocumentsMain = this.infoUserDocuments$.pipe(
    map((infoUser$) =>
      infoUser$.filter((infoUser) => infoUser.platform === "obsidiam")
    )
  );

  /**
   * we will compose all the observables with the map operator to create a flow of only the Documents Obsicash
   */
  readonly infoUserDocumentsObsicash = this.infoUserDocuments$.pipe(
    map((infoUser$) =>
      infoUser$.filter((infoUser) => infoUser.platform === "obsicash")
    )
  );

  /**
   * the getter will return the last value emitted in countries subject
   */
  // @ts-ignore
  get countries(): Country[] {
    return this._countries.getValue();
  }

  // @ts-ignore
  get currenciesAll(): any[] {
    return this._currenciesAll.getValue();
  }
  // @ts-ignore
  get currenciesByProject(): any[] {
    return this._currenciesByProject.getValue();
  }

  // @ts-ignore
  get onboarding(): OnboardingObsicash {
    return this._onboarding.getValue();
  }

  // @ts-ignore
  get onboardingBlueBank(): OnboardingObsicash {
    return this._onboardingBlueBank.getValue();
  }

  // @ts-ignore
  get onboardingDidi(): OnboardingObsicash {
    return this._onboardingDidi.getValue();
  }

  // @ts-ignore
  get didiAdditionalData(): any {
    return this._didiAdditionalData.getValue();
  }
  // @ts-ignore
  // get generalCountries(): any[] {
  //   return this._generalCountries.getValue();
  // }

  // @ts-ignore
  get globalBlueBank(): Country[] {
    return this._globalBlueBank$.getValue();
  }
  // @ts-ignore
  get onboardingDocuments(): any[] {
    return this._onboardingDocuments.getValue();
  }
  // @ts-ignore
  get coinFiatList(): any[] {
    return this._coinFiatList.getValue();
  }
  // @ts-ignore
  get enabledModules(): [] {
    return this._enabledModules.getValue();
  }

  // @ts-ignore
  get additionalData(): any {
    return this._additionalData.getValue();
  }

  // @ts-ignore
  get blueBankAdditionalData(): any {
    return this._additionalData.getValue();
  }

  // @ts-ignore
  get transactionHistory(): any {
    return this._transactionHistory.getValue();
  }

  // @ts-ignore
  get accountWallets(): AccountWallet[] {
    return this._accountWallets.getValue();
  }

  // @ts-ignore
  get accountWalletsAll(): AccountWalletAll[] {
    return this._accountWalletsAll.getValue();
  }

  // @ts-ignore
  get accountBanks(): Accountbank[] {
    return this._accountBanks.getValue();
  }
  // @ts-ignore
  get accountInfoDidi(): Accountbank[] {
    return this._accountInfoDidi.getValue();
  }

  // @ts-ignore
  get bankAccountBanks(): Accountbank[] {
    return this._bankAccountBanks.getValue();
  }

  // @ts-ignore
  get verifyUserDocuments(): VerifyUserDocuments[] {
    return this._verifyUserDocuments.getValue();
  }

  // @ts-ignore
  get infoUserDocuments(): UserInfo[] {
    return this._infoUserDocuments.getValue();
  }

  /**
   * assigning a value to this.todos will push it onto the observable
   * and down to all of its subsribers (ex: this.countries = [])
   */
  // @ts-ignore
  set enabledModules(val: []) {
    this._enabledModules.next(val);
  }

  // @ts-ignore
  set countries(val: Country[]) {
    this._countries.next(val);
  }

  // @ts-ignore
  set currenciesAll(val: any[]) {
    this._currenciesAll.next(val);
  }
  // @ts-ignore
  set currenciesByProject(val: any[]) {
    this._currenciesByProject.next(val);
  }

  // @ts-ignore
  set onboarding(val: OnboardingObsicash) {
    this._onboarding.next(val);
  }

  // @ts-ignore
  set onboardingBlueBank(val: OnboardingObsicash) {
    this._onboardingBlueBank.next(val);
  }

  // @ts-ignore
  set onboardingDidi(val: OnboardingObsicash) {
    this._onboardingDidi.next(val);
  }
  // @ts-ignore
  get didiAdditionalData(val: any) {
    this._didiAdditionalData.next(val);
  }
  // @ts-ignore
  // set generalCountries(val: any[]) {
  //   this._generalCountries.next(val);
  // }
  // @ts-ignore
  set globalBlueBank(val: Country[]) {
    this._globalBlueBank$.next(val);
  }
  // @ts-ignore
  set onboardingDocuments(val: any[]) {
    this._onboardingDocuments.next(val);
  }
  // @ts-ignore
  set additionalData(val: any) {
    this._additionalData.next(val);
  }

  // @ts-ignore
  get blueBankAdditionalData(val: any) {
    this._additionalData.next(val);
  }
  // @ts-ignore
  get coinFiatList(val: any) {
    this._coinFiatList.next(val);
  }

  // @ts-ignore
  set transactionHistory(val: any) {
    this._transactionHistory.next(val);
  }

  // @ts-ignore
  set accountWallets(val: AccountWallet[]) {
    this._accountWallets.next(val);
  }

  // @ts-ignore
  set accountWalletsAll(val: AccountWalletAll[]) {
    this._accountWalletsAll.next(val);
  }

  // @ts-ignore
  set accountBanks(val: Accountbank[]) {
    this._accountBanks.next(val);
  }
  // @ts-ignore
  set accountInfoDidi(val: Accountbank[]) {
    this._accountInfoDidi.next(val);
  }

  // @ts-ignore
  set bankAccountBanks(val: Accountbank[]) {
    this._bankAccountBanks.next(val);
  }

  // @ts-ignore
  set verifyUserDocuments(val: DocumentIdentification[]) {
    this._verifyUserDocuments.next(val);
  }

  // @ts-ignore
  set infoUserDocuments(val: UserInfo[]) {
    this._infoUserDocuments.next(val);
  }

  /**
   * @description: method que obtiene todas las monedas asociadas a los proyectos
   *
   * */
  getAllCurrencies() {
    this.obsicashService
      .getCurrenciesAllProject()
      .toPromise()
      .then((response) => {
        if (response.status.code === "0") {
          this._currenciesAll.next(
            response.data[0].currenciesGlobal.filter((a) => a.active)
          );
          return false;
        }
        this._currenciesAll.next([]);
      });
  }
  /**
   * @description: method que obtiene todas las monedas asociadas a los proyectos
   *
   * */
  getAllCurrenciesByProject(id) {
    this.obsicashService
      .getCurrenciesAllProject()
      .toPromise()
      .then((response) => {
        if (response.status.code === "0") {
          let newArray = []
          if(response.data[0].currenciesGlobal.length > 0){
              response.data[0].currenciesGlobal.forEach((val) => {
                val.projects.forEach((a)=> {
                  if(a.idProject === id){
                    newArray.push(val);

                  }
                });
              });
          }
          else{
            newArray=[]
          }
          this._currenciesByProject.next(newArray)
          return false;
        }
        this._currenciesByProject.next([]);
      });
  }

  /**
   * the getter will return the last value emitted in banks subject
   */
  banks(country: Country): Bank[] {
    let banks: Bank[] = [];
    if (country) {
      this._countries.getValue().map((value) => {
        if (value.id === country.id) {
          banks = value.banks;
        }
        return null;
      });
    }
    return banks;
  }

  /**
   * the getter will return the last value emitted in account banks subject
   */
  filterAccount(wallet: AccountWallet): AccountBank[] {
    const listAccountBank: AccountBank[] = [];
    if (wallet) {
      this._accountBanks.getValue().map((accountBank) => {
        if (accountBank.currency === wallet.currency) {
          listAccountBank.push(accountBank);
        }
      });
    }
    return listAccountBank;
  }
  /**
   * the getter will return the last value emitted in account banks subject
   */
  filterAccountBb(wallet: any): AccountBank[] {
    const listAccountBank: AccountBank[] = [];
    if (wallet) {
      this._accountBanks.getValue().map((accountBank) => {
        if (
          accountBank.currency === wallet.currency ||
          accountBank.currency === wallet.name
        ) {
          listAccountBank.push(accountBank);
        }
      });
    }
    return listAccountBank;
  }

  /**
   * the getter will return the last value emitted in banks subject
   */
  // @ts-ignore
  currencies(country: Country): Currency[] {
    if (country) {
      return country.currencies;
    }
  }

  async fetchAllCountries() {
    this.countries = await this.obsicashService
      .getCountries()
      .toPromise()
      .then((response) => {
        if (response.status.code === "0") {
          this.onboarding = response.data[0].onboardingStageDTO[0];
          this.onboarding.country.iso3 = response.data[0].iso3;
          this.onboarding.country.flag = response.data[0].flag;
          // TODO solicitar un campo nuevo de newAccountColtefinanciera
          if (this.onboarding.createNewBankAccount) {
            localStorage.setItem("newAccountColtefinanciera", "yes");
          }

          this.onboarding.bank.code = response.data[0].banks[0].code;
          this.fetchAllAdditionalData(
            response.data[0].id,
            response.data[0].idProject
          ).then();
          this.onboarding.start = true;
          if (this.onboarding && this.onboarding.stage > 3) {
            this.fetchAllBankAccountsBank().then();
          }
          if (this.onboarding && this.onboarding.stage > 1) {
            this.onboarding.start = true;
            this.fetchAllVerifyUserDocuments(
              this.onboarding.country.code,
              this.onboarding.project.id,
              this.onboarding.documentNumber,
              this.onboarding.documentType
            ).then();
          }
          this.verifyUserDocumentColte(this.onboarding.project.id,this.onboarding.bank.code);

          this.addOnboardingPersistence(this.onboarding);
          this.loadingCountry = true;
          return response.data;
        }
        return [];
      });
  }

  async fetchAllBlueBankGlobal(setting, projectId, callback = () => { }) {
    const request = {
      currencyId: setting.currencyId,
      showAllCountries: setting.showAllCountries,
    };
    return await this.obsidiamJweComponent
      .encodeJwe(
        environment.jweUrls.URL_POST_OBSICASH_BLUEBANK_GLOBAL.url,
        request,
        (resEnc) => {
          return this.obsicashService
            .getBlueBankGlobal(resEnc)
            .toPromise()
            .then((response) => {
              if (response.status.code === "0") {
                let dataFilte, dataOnboarding;
                if (response.data.length > 0) {
                  dataFilte = response.data.filter(
                    (project) => project.idProject === projectId
                  );
                  dataOnboarding = dataFilte[0];
                }

                if (dataOnboarding) {
                  if (!this.onboardingBlueBank) {
                    this.onboardingBlueBank = new OnboardingObsicash();
                  }
                  if (!localStorage.getItem("onboardingtype")) {
                    localStorage.setItem("onboardingtype", "bluebank");
                  }
                  this.addStartOnboardingBlueBank(true);
                  // project empty in state onboarding
                  if (dataOnboarding.onboardingStageDTO[0].id !== undefined) {
                    this.onboardingBlueBank.id =
                      dataOnboarding.onboardingStageDTO[0].id;
                  } else {
                    this.onboardingBlueBank.id = null;
                  }
                  // project empty in state onboarding
                  if (
                    dataOnboarding.onboardingStageDTO[0].project ||
                    dataOnboarding.onboardingStageDTO[0].project.id == null
                  ) {
                    this.onboardingBlueBank.project = {};
                    this.onboardingBlueBank.project.id =
                      dataOnboarding.idProject;
                  } else {
                    this.onboardingBlueBank.project =
                      dataOnboarding.onboardingStageDTO[0].project;
                  }
                  //
                  // if (
                  //   this.onboardingBlueBank.setting) {
                  //
                  //   let optionCurrency = localStorage.getItem("optionCurrency");
                  //   if (
                  //     optionCurrency !== this.onboardingBlueBank.setting.currencyId
                  //   ) {
                  //     this.onboardingBlueBank.InitialCurrency = true;
                  //   } else {
                  //     this.onboardingBlueBank.InitialCurrency = false;
                  //   }
                  // }

                  this.onboardingBlueBank.setting = setting;
                  // this.addInitialCodeCurrency(this.onboardingBlueBank.currencyCode)
                  // if(this.onboardingBlueBank.currencyCode ===""){

                  this.onboardingBlueBank.currencyCode = this.getCurrencyCode(
                    dataOnboarding.currencies,
                    parseInt(this.onboardingBlueBank.setting.currencyId)
                  );
                  // }

                  this.onboardingBlueBank.stage =
                    dataOnboarding.onboardingStageDTO[0].stage;
                  this.onboardingBlueBank.country =
                    dataOnboarding.onboardingStageDTO[0].country;
                  this.onboardingBlueBank.country.iso3 = dataOnboarding.iso3;
                  this.onboardingBlueBank.country.flag = dataOnboarding.flag;
                  this.onboardingBlueBank.country.code = dataOnboarding.code;
                  this.onboardingBlueBank.country.id = dataOnboarding.id;
                  this.onboardingBlueBank.bank = dataOnboarding.banks;

                  this.onboardingBlueBank.type = "bluebank";
                  if (!this.onboardingBlueBank.blueBank) {
                    this.onboardingBlueBank.blueBank = new BlueBank();
                  }
                  // step two
                  this.onboardingBlueBank.blueBank.countryIdRes =
                    dataOnboarding.onboardingStageDTO[0].countryOfResidenceId;
                  this.onboardingBlueBank.blueBank.stateIdRes =
                    dataOnboarding.onboardingStageDTO[0].addressFirstLevelId;
                  this.onboardingBlueBank.blueBank.cityRes =
                    dataOnboarding.onboardingStageDTO[0].cityOfResidence;
                  this.onboardingBlueBank.blueBank.addressRes =
                    dataOnboarding.onboardingStageDTO[0].addressDetail;
                  this.onboardingBlueBank.blueBank.countryOfBirthId =
                    dataOnboarding.onboardingStageDTO[0].countryOfBirthId;
                  this.onboardingBlueBank.blueBank.cityOfBirth =
                    dataOnboarding.onboardingStageDTO[0].cityOfBirth;
                  this.onboardingBlueBank.blueBank.maritalStatusId =
                    dataOnboarding.onboardingStageDTO[0].maritalStatusId;
                  this.onboardingBlueBank.blueBank.nationalityId =
                    dataOnboarding.onboardingStageDTO[0].nationalityId;
                  this.onboardingBlueBank.blueBank.doubleNationality =
                    dataOnboarding.onboardingStageDTO[0].doubleNationality;
                  this.onboardingBlueBank.blueBank.otherNationalityId =
                    dataOnboarding.onboardingStageDTO[0].otherNationalityId;
                  this.onboardingBlueBank.blueBank.occupationId =
                    dataOnboarding.onboardingStageDTO[0].jobOccupationId;
                  this.onboardingBlueBank.blueBank.economicActivityId =
                    dataOnboarding.onboardingStageDTO[0].economicActivityId;
                  this.onboardingBlueBank.blueBank.professionId =
                    dataOnboarding.onboardingStageDTO[0].professionId;
                  // step three
                  this.onboardingBlueBank.blueBank.monthly_income =
                    dataOnboarding.onboardingStageDTO[0].monthlyIncome;
                  this.onboardingBlueBank.blueBank.other_annual_income =
                    dataOnboarding.onboardingStageDTO[0].otherAnnualIncome;
                  this.onboardingBlueBank.blueBank.description_annual_income =
                    dataOnboarding.onboardingStageDTO[0].descriptionAnnualIncome;
                  this.onboardingBlueBank.blueBank.country =
                    dataOnboarding.onboardingStageDTO[0].taxCountryId;
                  this.onboardingBlueBank.blueBank.type_of_reference_document =
                    dataOnboarding.onboardingStageDTO[0].typeOfReferenceDocument;
                  this.onboardingBlueBank.blueBank.tax_reference_number =
                    dataOnboarding.onboardingStageDTO[0].taxReferenceNumber;

                  this.onboardingBlueBank.blueBank.initialDeposit =
                    dataOnboarding.onboardingStageDTO[0].initialDeposit;
                  this.onboardingBlueBank.blueBank.monthlyDeposits =
                    dataOnboarding.onboardingStageDTO[0].monthlyDeposits;
                  this.onboardingBlueBank.blueBank.totalMonthlyDeposits =
                    dataOnboarding.onboardingStageDTO[0].totalMonthlyDeposits;
                  this.onboardingBlueBank.blueBank.monthlyWithdraws =
                    dataOnboarding.onboardingStageDTO[0].monthlyWithdraws;
                  this.onboardingBlueBank.blueBank.totalMonthlyWithdraws =
                    dataOnboarding.onboardingStageDTO[0].totalMonthlyWithdraws;

                  this.onboardingBlueBank.blueBank.employer =
                    dataOnboarding.onboardingStageDTO[0].employee;
                  this.onboardingBlueBank.blueBank.employerName =
                    dataOnboarding.onboardingStageDTO[0].employerName;
                  this.onboardingBlueBank.blueBank.callingCode =
                    dataOnboarding.onboardingStageDTO[0].callingCode;
                  this.onboardingBlueBank.blueBank.employerTelephone =
                    dataOnboarding.onboardingStageDTO[0].employerTelephone;
                  this.onboardingBlueBank.blueBank.employerCountryId =
                    dataOnboarding.onboardingStageDTO[0].employerCountryId;
                  this.onboardingBlueBank.blueBank.employerState =
                    dataOnboarding.onboardingStageDTO[0].employerState;
                  this.onboardingBlueBank.blueBank.employerAddress =
                    dataOnboarding.onboardingStageDTO[0].employerAddress;
                  this.onboardingBlueBank.blueBank.companyWebPage =
                    dataOnboarding.onboardingStageDTO[0].companyWebPage;
                  this.onboardingBlueBank.blueBank.bussinessEmail =
                    dataOnboarding.onboardingStageDTO[0].bussinessEmail;
                  this.onboardingBlueBank.blueBank.employerCity =
                    dataOnboarding.onboardingStageDTO[0].employerCity;

                  // step fourth
                  this.onboardingBlueBank.blueBank.currencyAccount =
                    dataOnboarding.onboardingStageDTO[0].currencyAccountId;
                  this.onboardingBlueBank.blueBank.mainCurrency =
                    dataOnboarding.onboardingStageDTO[0].mainCurrencyId;

                  this.onboardingBlueBank.blueBank.secondCurrency =
                    dataOnboarding.onboardingStageDTO[0].secondCurrencyId;
                  this.onboardingBlueBank.blueBank.fundsOriginId =
                    dataOnboarding.onboardingStageDTO[0].fundsOriginId;
                  this.onboardingBlueBank.blueBank.bothCurrencies =
                    dataOnboarding.onboardingStageDTO[0].bothCurrencies;
                  // step five
                  this.onboardingBlueBank.blueBank.politicallyExposed =
                    dataOnboarding.onboardingStageDTO[0].politicallyExposed;
                  this.onboardingBlueBank.blueBank.relationshipId =
                    dataOnboarding.onboardingStageDTO[0].relationshipId;
                  this.onboardingBlueBank.blueBank.nameTitle =
                    dataOnboarding.onboardingStageDTO[0].nameTitle;
                  this.onboardingBlueBank.blueBank.functionLevel =
                    dataOnboarding.onboardingStageDTO[0].functionLevel;
                  this.onboardingBlueBank.blueBank.dateBecame =
                    dataOnboarding.onboardingStageDTO[0].dateBecame;
                  this.onboardingBlueBank.blueBank.dateStopped =
                    dataOnboarding.onboardingStageDTO[0].dateStopped;
                  this.onboardingBlueBank.blueBank.relationship =
                    dataOnboarding.onboardingStageDTO[0].relationship;

                  this.onboardingBlueBank.blueBank.doc1 =
                    dataOnboarding.onboardingStageDTO[0].doc1;
                  this.onboardingBlueBank.blueBank.doc1FileName =
                    dataOnboarding.onboardingStageDTO[0].doc1Filename;

                  this.onboardingBlueBank.blueBank.doc2 =
                    dataOnboarding.onboardingStageDTO[0].doc2;
                  this.onboardingBlueBank.blueBank.doc2FileName =
                    dataOnboarding.onboardingStageDTO[0].doc2Filename;
                  this.onboardingBlueBank.blueBank.termsConditions =
                    dataOnboarding.onboardingStageDTO[0].termsConditions;
                  this.onboardingBlueBank.blueBank.termsConditionsIp =
                    dataOnboarding.onboardingStageDTO[0].termsConditionsIp;
                  this.getAllCurrenciesByProject( this.onboardingBlueBank.project.id);
                  this.fetchAllAdditionalDataBb(
                    dataOnboarding.id,
                    dataOnboarding.idProject
                  ).then();
                  this.verifyUserDocumentsBB(
                    dataOnboarding.idProject,
                    dataOnboarding.banks[0].code
                  ).then();

                  this.getOnboardingDocumentsBlueBank(
                    dataOnboarding.banks[0].code,
                    dataOnboarding.idProject,
                    parseInt(response.status.code)
                  ).then();

                  // this._generalCountries.next(dataOnboarding.generalCountries);
                  this.addOnboardingBlueBankPersistence(
                    this.onboardingBlueBank
                  );
                  callback();
                  this._globalBlueBank$.next(response.data);
                }
              } else {
                this._globalBlueBank$.next([]);
              }
            });
        }
      )
      .then();
  }

  /**
   * @description: function that obtains the onboarding data for didi
   * @param setting
   * @param callback
   * @returns
   */
  async fetchAllDidiGlobal(setting, projectId, callback = () => { }) {
    const request = {
      currencyId: setting.currencyId,
      showAllCountries: setting.showAllCountries,
    };

    return await this.obsidiamJweComponent
      .encodeJwe(
        environment.jweUrls.URL_POST_OBSICASH_BLUEBANK_GLOBAL.url,
        request,
        (resEnc) => {
          return this.obsicashService
            .getBlueBankGlobal(resEnc)
            .toPromise()
            .then((response) => {
              if (response.status.code === "0") {
                let dataFilte, dataOnboarding;
                if (response.data.length > 0) {
                  dataFilte = response.data.filter(
                    (project) => project.idProject === projectId
                  );
                  dataOnboarding = dataFilte[0];
                }
                if (dataOnboarding) {
                  if (!this.onboardingDidi) {
                    this.onboardingDidi = new OnboardingObsicash();
                  }
                  //seteamos el onboarding type
                  if (!localStorage.getItem("onboardingtype")) {
                    localStorage.setItem("onboardingtype", "didi");
                  }
                  this.onboardingDidi = dataOnboarding.onboardingStageDTO[0];

                  this.onboardingDidi.country.iso3 = dataOnboarding.iso3;
                  this.onboardingDidi.country.flag = dataOnboarding.flag;
                  this.onboardingDidi.country.code = dataOnboarding.code;
                  this.onboardingDidi.country.id = dataOnboarding.id;
                  if (dataOnboarding.onboardingStageDTO[0].id !== undefined) {
                    this.onboardingDidi.id =
                      dataOnboarding.onboardingStageDTO[0].id;
                    this.onboardingDidi.start = true;
                  } else {
                    this.onboardingDidi.id = null;
                  }

                  // project empty in state onboarding
                  if (
                    dataOnboarding.onboardingStageDTO[0].project ||
                    dataOnboarding.onboardingStageDTO[0].project.id == null
                  ) {
                    this.onboardingDidi.project = {};
                    this.onboardingDidi.project.id = dataOnboarding.idProject;
                  } else {
                    this.onboardingDidi.project =
                      dataOnboarding.onboardingStageDTO[0].project;
                  }

                  this.onboardingDidi.bank = dataOnboarding.banks[0];
                 
                  this.onboardingDidi.setting = setting; // seteamos el request
                  this.onboardingDidi.currencyCode = this.getCurrencyCode(
                    dataOnboarding.currencies,
                    parseInt(this.onboardingDidi.setting.currencyId)
                  );
                  this.verifyUserDocumentsDidi(
                    dataOnboarding.idProject,
                    dataOnboarding.banks[0].code
                  ).then();

                  this.addOnboardingDidiPersistence(this.onboardingDidi);
                  callback();
                }
              } else {
                // this._globalBlueBank$.next([]);
              }
            });
        }
      )
      .then();
  }
  getCurrencyCode(currency, idC) {
    let value = "";
    currency.forEach((m) => {
      if (m.id === idC) {
        value = m.name;
      }
    });
    return value;
  }
  async fetchAllAccountWallets() {
    sessionStorage.removeItem("walletObsicash");
    await this.obsicashService
      .getWalletObsicash()
      .toPromise()
      .then(
        (response) => {
          if (response.status.code === "0") {
            this._accountWallets.next(response.data);
            this._loadingWallet.next(false);
            if (response.data.length > 0) {
              sessionStorage.setItem("walletObsicash", "true");
              localStorage.setItem("walletObsicash", "true");
            }
            return false;
          }
          this._accountWallets.next([]);
          localStorage.setItem("walletObsicash", "false");
          this._loadingWallet.next(false);
        },
        (reason) => console.log("error")
      );
  }

  async fetchAllAccountsBank() {
    await this.obsicashAssociateAccountService
      .getAssociateAccount()
      .toPromise()
      .then((response) => {
        if (response.status.code === "0") {
          this._accountBanks.next(response.data);
          return false;
        }
        this._accountBanks.next([]);
      });
  }

  async fetchAllBankAccountsBank() {
    const request = {
      bankId: this.onboarding.bank.code
        ? this.onboarding.bank.code
        : this.onboarding.bank.id,
      documentType: this.onboarding.documentType,
      documentNumber: this.onboarding.documentNumber,
    };

    this.obsidiamJweComponent.encodeJwe(
      environment.jweUrls.URL_POST_OBSICASH_ACCOUNT_BANK.url,
      request,
      (resEnc) => {
        this.obsicashOnboardingService
          .getAccountBanks(resEnc)
          .toPromise()
          .then((response: any) => {
            if (response.status.code === "0") {
              this._bankAccountBanks.next(response.data.accounts);
              return false;
            }
            this._bankAccountBanks.next([]);
          });
      }
    );
  }

  async fetchAllVerifyUserDocuments(
    countryId,
    projectId,
    documentNumber,
    documentType
  ) {
    const request = {
      projectId: projectId,
      countryId: countryId,
      documentNumber: documentNumber,
      documentType: documentType,
    };
    if (this.onboarding.bank.code) {
      request["bankId"] = this.onboarding.bank.code;
    }
    this.obsidiamJweComponent.encodeJwe(
      environment.jweUrls.URL_POST_OBSICASH_IDENTIFICATION_REGISTER.url,
      request,
      (resEnc) => {
        this.obsicashOnboardingService
          .getRegisteredIdentifications(resEnc)
          .toPromise()
          .then((response) => {
            if (response.status.code === "0") {
              this.addVerifyUserDocuments(response.data.validatedDocuments);
              this._verifyUserDocuments.next(response.data.validatedDocuments);
              return false;
            }
            this._verifyUserDocuments.next([]);
          });
      }
    );
  }

  async fetchAllAdditionalData(country, project) {
    if (country !== undefined && project !== undefined) {
      await this.obsicashOnboardingService
        .getAdditionalData(country, project)
        .toPromise()
        .then((response) => {
          if (response.status.code === "0") {
            response.data.addressLevels.forEach((value) => {
              if (
                parseInt(value.code) === this.onboarding.addressFirstLevelId
              ) {
                this.onboarding.addressFirstLevel = value;
              }
            });

            if (this.onboarding.addressFirstLevel) {
              this.onboarding.addressFirstLevel.addresses.forEach((value) => {
                if (
                  parseInt(value.code) === this.onboarding.addressSecondLevelId
                ) {
                  this.onboarding.addressSecondLevel = value;
                }
              });
            }
            this.addDataAdditional(response.data);
            this.addOnboardingPersistence(this.onboarding);
            this._additionalData.next(response.data);
            return false;
          } else {
            this._additionalData.next({});
          }
        });
    }
  }

  /**
   * metodo de adicional data para blue bank
   */
  async fetchAllAdditionalDataBb(country, project) {
    if (country !== undefined && project !== undefined) {
      await this.obsicashOnboardingService
        .getAdditionalData(country, project)
        .toPromise()
        .then((response) => {
          if (response.status.code === "0") {
            this._blueBankAdditionalData.next(response.data);

            return false;
          } else {
            this._blueBankAdditionalData.next({});
          }
        });
    }
  }

  async fetchAllInfoUserDocuments() {
    this.obsicashService
      .getInfoUserVerification()
      .toPromise()
      .then((response) => {
        if (response.status.code === "0") {
          const userInfos: UserInfo[] = [];
          if (response.data.mainDocument) {
            userInfos.push(response.data.mainDocument);
          }
          if (response.data.obsicashDocuments.length > 0) {
            response.data.obsicashDocuments.forEach((document) => {
              userInfos.push(document);
            });
          }
          this._infoUserDocuments.next(userInfos);
        }
      });
  }

  addCountryOnboarding(country: Country) {
    this.onboarding.country = country;
  }

  addStatusMigration(statusMigration: StatusMigration) {
    this.onboarding.migrationStatus = statusMigration.valueOf();
  }

  addBankOnboarding(bank: Bank) {
    this.onboarding.bank = bank;
  }

  addIdentificationOnboarding(identification: DocumentIdentification) {
    this.onboarding.documentType = identification.idType;
    this.onboarding.documentNumber = identification.idNumber;
  }

  addAccountBankOnboarding(accountbank: AccountBank) {
    this.onboarding.bankAccountNumber = accountbank.accountNumber;
    this.onboarding.bankAccountNumber = accountbank.accountType;
  }

  getStartOnboarding() {
    if (localStorage.getItem("onboarding")) {
      this.onboarding = JSON.parse(localStorage.getItem("onboarding"));
    } else {
      this.onboarding = new OnboardingObsicash();
    }
  }

  addStartOnboarding(value: boolean) {
    if (value) {
      this.onboarding = new OnboardingObsicash();
      this.onboarding.start = value;
      localStorage.setItem("onboarding", JSON.stringify(this.onboarding));
    } else {
      localStorage.removeItem("onboarding");
    }
  }

  addOnboardingPersistence(onboarding: OnboardingObsicash) {
    try {
      localStorage.setItem("onboarding", JSON.stringify(onboarding));
    } catch (e) { }
  }

  addOnboardingDidiPersistence(onboarding: OnboardingObsicash) {
    try {
      localStorage.setItem("onboardingDidi", JSON.stringify(onboarding));
    } catch (e) { }
  }

  addDataAdditional(data: any) {
    localStorage.setItem("dataAditional", JSON.stringify(data));
  }

  getNewAccountColtefinanciera() {
    if (localStorage.getItem("newAccountColtefinanciera")) {
      return JSON.parse(localStorage.getItem("newAccountColtefinanciera"));
    }
    return null;
  }

  getDataAdditional() {
    if (localStorage.getItem("dataAditional")) {
      return JSON.parse(localStorage.getItem("dataAditional"));
    }
    return null;
  }

  addVerifyUserDocuments(data: any) {
    localStorage.setItem("verifyUserDocuments", JSON.stringify(data));
  }

  getVerifyUserDocuments() {
    if (localStorage.getItem("verifyUserDocuments")) {
      return JSON.parse(localStorage.getItem("verifyUserDocuments"));
    }
    return null;
  }

  getActiveObsicashProject(pstatus: string, projectId: number) {
    let active = false;
    this._loadingObsicash.next(true);
    if (this.infoUserDocuments) {
      this.infoUserDocuments.forEach((docJumio) => {
        let platform = docJumio.platform.toString().toUpperCase();
        if (
          docJumio &&
          docJumio.status === pstatus &&
          platform === "OBSICASH" &&
          docJumio.projectId === projectId
        ) {
          active = true;
        }
      });
    }
    this._loadingObsicash.next(false);
    return active;
  }

  getActiveObsicash(pstatus: string) {
    let active = false;
    this._loadingObsicash.next(true);
    if (this.infoUserDocuments) {
      this.infoUserDocuments.forEach((document) => {
        let platform = document.platform.toString().toUpperCase();
        if (
          document &&
          document.status === pstatus &&
          platform === "OBSICASH"
        ) {
          active = true;
        }
      });
    }
    this._loadingObsicash.next(false);
    return active;
  }

  changeLng(lng) {
    this._lng.next(lng);
  }

  setLoadingOnboarding(value: boolean) {
    this._loadingOnboarding.next(value);
  }

  addOnboardingBlueBankPersistence(onboardingBluebank: OnboardingObsicash) {
    try {
      localStorage.setItem(
        "onboardingBlueBank",
        JSON.stringify(onboardingBluebank)
      );
    } catch (e) { }
  }

  addStartOnboardingBlueBank(value: boolean) {
    if (value) {
      // this.onboardingBlueBank = new OnboardingObsicash();
      this.onboardingBlueBank.start = value;
      localStorage.setItem(
        "onboardingBlueBank",
        JSON.stringify(this.onboardingBlueBank)
      );
    } else {
      localStorage.removeItem("onboardingBlueBank");
    }
  }

  async fetchAllAccountWalletsObsicash() {
    // sessionStorage.removeItem("walletObsicash");
    await this.obsicashService
      .getAllWalletObsicash()
      .toPromise()
      .then(
        (response) => {
          if (response.status.code === "0") {
            if (response.data.length > 0) {
              localStorage.setItem("walletObsicash", "true");
            }
            this._accountWalletsAll.next(response.data);

            return false;
          }

          this._accountWalletsAll.next([]);
          localStorage.setItem("walletObsicash", "false");
          // this._loadingWallet.next(false);
        },
        (reason) => console.log("error")
      );
  }
  async fetchAllTransactionHistory() {
    // sessionStorage.removeItem("walletObsicash");
    await this.obsicashService
      .getHistory()
      .toPromise()
      .then(
        (response) => {
          if (response.status.code === "0") {
            this._transactionHistory.next(response.data);
            return false;
          }
          this._transactionHistory.next([]);
          // this._loadingWallet.next(false);
        },
        (reason) => console.log("error")
      );
  }

  async getOnboardingDocumentsBlueBank(bankId, projectId, status) {
    const request = {
      bankId,
      projectId,
      status,
    };
    this.obsicashService
      .getOnboardingDocuments(request, null)
      .toPromise()
      .then((response) => {
        if (response.status) {
          this._onboardingDocuments.next(response.data);
        } else {
          alert("error");
          this._onboardingDocuments.next([]);
        }
      });
  }
async verifyUserDocumentColte(projectId, bankId){
  const request = {
    projectId,
    bankId
  }
  this.obsidiamJweComponent.encodeJwe(
    environment.jweUrls.URL_POST_OBSICASH_VERIFICATIONS_GLOBAL.url,
    request,
    (resEnc) => {
      this.obsicashService
        .verificationsGlobal(resEnc)
        .toPromise()
        .then((response) => {
          if( response.status.code === '0'){
            if(response.data.validatedDocuments.length > 0){
              this._verifyUserDocumentsColte.next(response.data.validatedDocuments);

            }else{
              this._verifyUserDocumentsColte.next([]);

            }
          }
          else{
            this._verifyUserDocumentsColte.next([]);

          }
        })
    })
}

  async verifyUserDocumentsBB(projectId, bankId) {
    const request = {
      projectId,
      bankId,
    };
    this.obsidiamJweComponent.encodeJwe(
      environment.jweUrls.URL_POST_OBSICASH_VERIFICATIONS_GLOBAL.url,
      request,
      (resEnc) => {
        this.obsicashService
          .verificationsGlobal(resEnc)
          .toPromise()
          .then((response) => {
            if (response.status.code === "0") {
              // this.addVerifyUserDocuments(response.data.validatedDocuments);
              this._verifyUserDocumentsBB.next(
                response.data.validatedDocuments
              );
              response.data.validatedDocuments.forEach((validatedDocument) => {
                if (
                  validatedDocument.idType === "PASSPORT" &&
                  (validatedDocument.status === "APPROVED_VERIFIED" ||
                    validatedDocument.status === "VERIFIED" ||
                    validatedDocument.status === "SUCCESS")
                ) {
                  this.onboardingBlueBank.documentNumber =
                    validatedDocument.idNumber;
                  this.onboardingBlueBank.documentType =
                    validatedDocument.idType;
                }
              });
              // if (
              //   response.data.validatedDocuments[0] &&
              //   response.data.validatedDocuments[0].idNumber
              // ) {
              //   this.onboardingBlueBank.documentNumber =
              //     response.data.validatedDocuments[0].idNumber;
              // }
              // if (
              //   response.data.validatedDocuments[0] &&
              //   response.data.validatedDocuments[0].idType
              // ) {
              //   this.onboardingBlueBank.documentType =
              //     response.data.validatedDocuments[0].idType;
              // }

              return false;
            }
            this._verifyUserDocumentsBB.next([]);
          });
      }
    );
  }
  async verifyUserDocumentsDidi(projectId, bankId) {
    const request = {
      projectId,
      bankId,
    };
    this.obsidiamJweComponent.encodeJwe(
      environment.jweUrls.URL_POST_OBSICASH_VERIFICATIONS_GLOBAL.url,
      request,
      (resEnc) => {
        this.obsicashService
          .verificationsGlobal(resEnc)
          .toPromise()
          .then((response) => {
            if (response.status.code === "0") {
              // this.addVerifyUserDocuments(response.data.validatedDocuments);
              this._verifyUserDocumentsDidi.next(
                response.data.validatedDocuments
              );
              response.data.validatedDocuments.forEach((validatedDocument) => {
                if (
                  validatedDocument.status === "APPROVED_VERIFIED" ||
                  validatedDocument.status === "VERIFIED" ||
                  validatedDocument.status === "SUCCESS"
                ) {
                  this.onboardingDidi.documentNumber =
                    validatedDocument.idNumber;
                  this.onboardingDidi.documentType = validatedDocument.idType;
                  this.addOnboardingDidiPersistence(this.onboardingDidi);
                }
              });
              return false;
            }
            this._verifyUserDocumentsDidi.next([]);
          });
      }
    );
  }

  /**
   * Methods used in the onboarding Didi
   */


  async getAdditionDataDidi() {
    this.obsicashService
      .getAdditionalDataDidi()
      .toPromise()
      .then(
        (data:any) => {
          let dataString = JSON.parse(data)
          if (dataString.status.code === "0") {
            this._didiAdditionalData.next(dataString.data.form);
          } else {
            this._didiAdditionalData.next({});
          }
        },
        (reason) => console.log("error")
      );
  }

  async getAccountInfoDidi(request?) {
    request = ""
    return await this.obsidiamJweComponent
      .encodeJwe(environment.jweUrls.URL_POST_DIDI_ACCOUNT_INFO.url,
        request,
        () => {
          return this.obsicashService
            .getAccountInfoDidi()
            .toPromise()
            .then((response) => {

              if (response.status.code === '0') {
                // this._accountInfoDidi.next(data.account.accounts[1])
                if(response.data.account){
                  let dataAccount = response.data.account.accounts[0]
                  dataAccount['hasAnAccount'] = response.data.hasAnAccount
                  if(dataAccount.hasAnAccount){
                    localStorage.setItem("accountDidi", "true");
                  }
                  this._accountInfoDidi.next(dataAccount)


                }else{
                  
                  this._accountInfoDidi.next([])
                  localStorage.setItem("accountDidi", "false");

                }

              }
              else {
                
                this._accountInfoDidi.next([]);

              }
            })
        }
      );
  }
}
